import { Column, DataTable } from "@/components/data-table";
import { extractText } from "@/shared/utils";
import { StackProps } from "@mui/material";

interface PrintComponentTableProps extends StackProps{
    columns: Column[],
    rows: any[]
}

export default function PrintComponentTable({
    columns,
    rows,
    ...props
}: PrintComponentTableProps) {
    return <DataTable {...props}>
        <DataTable.Content
            rows={rows}
            columns={columns.map(c => ({
                ...c,
                render: (r, i) => extractText(c.render(r, i)),
                header: extractText(c.header)
            }))}
            emptyText=""
        />
    </DataTable>
}